export const DEFAULT_TEXT = {
  ticketEntryHeader: 'Scan or Tap Your Tickets',
  ticketEntrySubheader: 'Touch Continue when you are ready to check out',
  manualEntryButton: 'Type your number',
  manualEntryHeader: 'Look Up Your Ticket',
  manualEntrySubheader: 'Please enter the ticket number',
  manualEntryPlaceholder: 'Ticket number',
  goBackWarning: 'You will have to enter your tickets again'
};
